import { styled } from "styled-components";

export const ReviewItemContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid #383838;
  border-radius: 20px;
  padding: 24px;
  a {
    text-decoration-line: none;
    color: #383838;
  }
`;
